export default __webpack_public_path__ + "static/banner-the-best-time-to-buy-a-new-car-c9db404d62764b2e45bea026003ca1af.jpg";